const HeatingGallerySection = () => {
  const heatingImages = [
    {
      title: 'Underfloor Heating Installation',
      image: 'https://static.readdy.ai/image/2b8febc409be403949093d91f25c447f/15d9addd3d9e538202701c3530865f7d.jpeg',
    },
    {
      title: 'Heating',
      image: 'https://static.readdy.ai/image/2b8febc409be403949093d91f25c447f/b3ea541f237b5345e44b3e1b639c4377.jpeg',
    },
    {
      title: 'Contemporary Radiator Design',
      image: 'https://public.readdy.ai/ai/img_res/630e4a184d9ec5533ab538ee22c84797.jpg',
    },
  ];

  return (
    <section className="py-20 lg:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-12">
          <div className="mb-6 lg:mb-0">
            <p className="text-accent text-sm font-semibold uppercase tracking-wider mb-3">
              QUALITY INSTALLATIONS
            </p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-primary">
              Modern Heating Systems We Install
            </h2>
          </div>
          <p className="text-gray-600 text-lg max-w-xl">
            Explore our professional heating installations featuring the latest technology and energy-efficient solutions.
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {heatingImages.map((item, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-xl cursor-pointer"
            >
              <div className="aspect-[4/3] w-full h-full">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                <div className="p-6 w-full">
                  <h3 className="text-white font-bold text-xl mb-2">{item.title}</h3>
                  <button className="text-white text-sm font-medium flex items-center space-x-2 whitespace-nowrap">
                    <span>View Details</span>
                    <i className="ri-arrow-right-line"></i>
                  </button>
                </div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-white/90 backdrop-blur-sm p-4 transform translate-y-0 group-hover:translate-y-full transition-transform duration-300">
                <h3 className="text-primary font-semibold text-lg">{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeatingGallerySection;